import { act } from 'react-dom/test-utils';
import data from 'shared/data';
import { REMOVE_FILTER, SET_AGE, SET_FILTER, SET_PARTICLES_SIZE } from './constants';

const initialState = {
  loading: true,
  particlesSize: data.length,
  filters: {
    type: '*',
    age: [20, 77],
    gender: '*',
    category: '*',
    state: '*',
    name: '',
    institution: ''
  }
}

const general = (state = initialState, action) => {
  let {filters} = state;
  switch(action.type){
    case REMOVE_FILTER:
      const i = filters[action.key].indexOf(action.value);
      console.log('i', i);
      filters[action.key] = filters[action.key].splice(i, 1);

      if(!filters[action.key].length){
        filters[action.key] = "*";
      }

      return {
        ...state,
        filters
      }
    case SET_FILTER:
      if(action.value === "*"){
        filters[action.key] = "*";
      }else if(action.unique){
        filters[action.key] = action.value;
      }else{
        if(typeof filters[action.key] !== "object"){
          filters[action.key] = [];
        }

        filters[action.key] = [...filters[action.key], action.value];
      }
      return {
        ...state,
        filters
      }
    case SET_AGE:
      filters.age = action.value;
      return {...state, filters}
    case SET_PARTICLES_SIZE:
      return {...state, particlesSize: action.size}
    default:
      return state;
  }
}

export default general;